import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfUse.css';
import { FaArrowLeft } from 'react-icons/fa';

const TermsOfUse = () => {
  return (    <div className="terms-page">
      <div className="terms-container">
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>
        
        <div className="terms-header">
          <h1 className="terms-title">Terms of Use</h1>
          <p className="terms-subtitle">Last updated: June 24, 2025</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using Aesthetic AI Receptionist services, you accept and agree to be bound by 
              the terms and provision of this agreement. If you do not agree to abide by the above, please 
              do not use this service.
            </p>
          </section>

          <section className="terms-section">
            <h2>Service Description</h2>
            <p>
              Aesthetic AI Receptionist provides an AI-powered virtual receptionist service specifically 
              designed for dental practices. Our service includes:
            </p>
            <ul>
              <li>24/7 automated phone answering and call handling</li>
              <li>Appointment scheduling and management</li>
              <li>Patient information collection and verification</li>
              <li>Integration with practice management systems</li>
              <li>Automated follow-up communications</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>User Responsibilities</h2>
            <p>As a user of our service, you agree to:</p>
            <ul>
              <li>Provide accurate and complete information about your practice</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Use the service in compliance with all applicable laws and regulations</li>
              <li>Not use the service for any unlawful or fraudulent purposes</li>
              <li>Notify us immediately of any unauthorized access to your account</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>Payment Terms</h2>
            <p>
              Service fees are billed monthly in advance. All payments are due within 30 days of the invoice date. 
              Failure to make timely payments may result in service suspension or termination. All fees are 
              non-refundable except as expressly stated in our refund policy.
            </p>
          </section>

          <section className="terms-section">
            <h2>Privacy and Data Protection</h2>
            <p>
              We are committed to protecting your privacy and maintaining HIPAA compliance. All patient health 
              information is handled in accordance with our Privacy Policy and applicable healthcare regulations. 
              We implement appropriate safeguards to protect sensitive information from unauthorized access, 
              use, or disclosure.
            </p>
          </section>

          <section className="terms-section">
            <h2>Service Availability</h2>
            <p>
              While we strive to provide 99.9% uptime, we cannot guarantee uninterrupted service availability. 
              We reserve the right to perform maintenance, updates, and improvements that may temporarily 
              affect service availability. Users will be notified of planned maintenance in advance when possible.
            </p>
          </section>

          <section className="terms-section">
            <h2>Limitation of Liability</h2>
            <p>
              Aesthetic AI Receptionist shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other 
              intangible losses, resulting from your use of the service.
            </p>
          </section>

          <section className="terms-section">
            <h2>Termination</h2>
            <p>
              Either party may terminate this agreement with 30 days written notice. Upon termination, your 
              access to the service will be discontinued, and all data will be retained for 90 days before 
              permanent deletion, unless otherwise required by law.
            </p>
          </section>

          <section className="terms-section">
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Users will be notified of significant 
              changes via email or through the service interface. Continued use of the service after changes 
              constitutes acceptance of the new terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>Contact Information</h2>
            <p>
              If you have any questions about these Terms of Use, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> legal@aesthetic-ai.com</p>
              <p><strong>Phone:</strong> (323) 283-8368</p>
              <p><strong>Address:</strong> 123 Healthcare Blvd, Suite 100, Medical City, CA 90210</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
